module.exports = __webpack_public_path__ + "img/invision-site@2x.3df888f0.png";